export enum GroupByOption {
  DAY = "day",
  VENDOR = "vendor",
  TECHNICIAN = "technician",
  MANAGER = "manager",
  PARTICIPANT = "participant",
  PLACE = "place",
}
